module.exports = __webpack_public_path__ + "img/index_1.4a02eb41.png";